import React from 'react';
import { Github, Gitlab, GitBranch } from 'lucide-react';
import GiteaIcon from './GiteaIcon';

// Registry `icon` names → glyphs. A provider without one gets the generic branch.
const ICONS = { github: Github, gitlab: Gitlab, gitea: GiteaIcon };

/** The bare glyph component for a provider id (no wrapper) — for inline use in pickers. */
export function providerGlyph(id) {
  return ICONS[id] || GitBranch;
}

export default function ProviderIcon({ id, size = 16 }) {
  const Icon = providerGlyph(id);
  return (
    <span className="git-row-icon" aria-hidden="true">
      <Icon size={size} />
    </span>
  );
}
